import { render, staticRenderFns } from "./MoldForm.vue?vue&type=template&id=3d564ca0&"
import script from "./MoldForm.vue?vue&type=script&lang=js&"
export * from "./MoldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports